import { API_BASE_URL } from "utils/constants";

const CrawlingManagementPaths = {
  get_url: `${API_BASE_URL}/crawling-url/get_list_crawling_url/?:query`,

  add_url: `${API_BASE_URL}/crawling-url/add_new_crawling_url`,

  delete_url: `${API_BASE_URL}/crawling-url/delete_crawling_url`,

  edit_url: `${API_BASE_URL}/crawling-url/update_crawling_url`,

  get_detail_urls: `${API_BASE_URL}/crawling-url/get_detail_url/?:query`,

  get_frequency: `${API_BASE_URL}/common/crawling_frequency`,

  delete_summary: `${API_BASE_URL}/crawling-url/delete_info_detail_url`,

  set_frequency: `${API_BASE_URL}/crawling-url/set_frequency_crawling`,

  get_category: `${API_BASE_URL}/common/category_url`,
};

export default CrawlingManagementPaths;
